import React, {lazy, memo, Suspense, useEffect} from 'react';
import {useLocation} from 'react-router-dom';

import {useNavContext, useNavUpdaterContext} from '../NavContextProvider';

const AppSearchModal = lazy(() => import('./AppSearchModal'));

const AppSearchComp = () => {
  const {searchActive} = useNavContext();
  const {deactivateSearch} = useNavUpdaterContext();
  const location = useLocation();

  // Clear the launcher and hide it whenever the route changes.
  useEffect(() => {
    deactivateSearch();
  }, [deactivateSearch, location.pathname]);

  if (!searchActive) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <AppSearchModal onClose={deactivateSearch} />
    </Suspense>
  );
};

export const AppSearch = memo(AppSearchComp);
